import {
  EfsMelcoEfsModelsMappingCondition,
  EfsMelcoEfsModelsMappingGroup,
  EfsMelcoEfsModelsMappingOutput,
  ProductionFulfillmentApi,
  useAuthenticatedAPIConfig,
  useFormSubmit,
} from "melco-shared-logic";

export type DesignMappingDetailFormValueType = {
  id: string;
  name: string;
  global?: boolean;
  config_type?: string | null;
  format_id: string;
  conditions: EfsMelcoEfsModelsMappingCondition[];
  outputs: EfsMelcoEfsModelsMappingOutput[];
  service_type: string;
  folder_groups: EfsMelcoEfsModelsMappingGroup[];
};

export const useDesignMappingFormSubmit = () => {
  const authenticatedApiConfig = useAuthenticatedAPIConfig();

  const onSubmit = useFormSubmit<DesignMappingDetailFormValueType>(
    async (values: DesignMappingDetailFormValueType, { resetForm }) => {
      const {
        id,
        name,
        global,
        config_type,
        format_id,
        conditions,
        outputs,
        service_type,
        folder_groups,
      } = values;

      const api = new ProductionFulfillmentApi(authenticatedApiConfig());

      await api.productionFulfillmentMappingsEdit({
        id,
        
        efsMelcoEfsModelsCreateMapping: {
          name,
          global,
          config_type,
          format_id,
          conditions,
          outputs,
          service_type,
          folder_groups,
        },
      });

      resetForm({ values });

      return { successMessages: [{ message: "default" }] };
    },
    { translationPrefix: "designMappings.detail.save" }
  );

  return onSubmit;
};
